// src/app/modules/ThreatAlerts/database/ThreatAlertsTable.jsx
import React from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as columnFormatters from "./column-formatters";

export function ThreatAlertsTable({
  alerts,
  loading,
  onAcknowledge,
  onResolve,
  currentPage,
  perPage,
  totalCount,
  onPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil((totalCount || 0) / (perPage || 10)));

  if (loading && !alerts.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>Loading…</div>;
  }

  if (!alerts.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>No threat alerts.</div>;
  }

  return (
    <div>
      <div className="sety-tbl-wrap">
        <table className="sety-tbl">
          <thead>
            <tr>
              <th>Alert</th>
              <th>Type</th>
              <th>Severity</th>
              <th>Status</th>
              <th>Created</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {alerts.map((row) => (
              <tr key={row.alert_id}>
                <td>{columnFormatters.AlertColumnFormatter(row.description, row)}</td>
                <td>{columnFormatters.AlertTypeColumnFormatter(row.alert_type, row)}</td>
                <td>{columnFormatters.SeverityColumnFormatter(row.severity, row)}</td>
                <td>{columnFormatters.StatusColumnFormatter(row.status, row)}</td>
                <td>{columnFormatters.DateFormatter(row.created_at, row)}</td>
                <td style={{ textAlign: 'right' }}>
                  {columnFormatters.ActionsColumnFormatter(null, row, 0, { onAcknowledge, onResolve })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 22px', borderTop: '1px solid var(--ink-100)',
        }}>
          <span className="sety-tbl-sub">Page {currentPage} of {totalPages}</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>
              <ChevronLeft size={14} />Prev
            </button>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
              Next<ChevronRight size={14} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
